module.exports = __webpack_public_path__ + "turn_off.png?6e311adc88ab0157b9533e7de90e7b9a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/turn_off.png
// module id = 327
// module chunks = 2